function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(248, 246, 241)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'rusty-red': 'rgb(165, 42, 42)','merlot-red': 'rgb(139, 0, 0)','space-blue': 'rgb(100, 149, 237)','swamp-green': 'rgb(85, 107, 47)','moondust-grey': 'rgb(112, 128, 144)','gunmetal-grey': 'rgb(169, 169, 169)','metal-bronze': 'rgb(139, 69, 19)','olive-green': 'rgb(143, 188, 143)','light-purple': 'rgb(221, 160, 221)','light-blue': 'rgb(173, 216, 230)','burgundy': 'rgb(139, 0, 0)','light-orange': 'rgb(255, 138, 0)','navy': 'rgb(70, 130, 180)','white-glossy': 'rgb(252, 252, 252)','black-glossy': 'rgb(37, 35, 36)','clear-orange': 'rgb(255, 138, 0)','clear-black': 'rgb(220, 219, 219)','metallic-black': 'rgb(37, 35, 36)','pearl-white': 'rgb(245, 247, 227)','royal': 'rgb(48, 92, 222)','dark-chocolate': 'rgb(113, 54, 0)','dark-heather': 'rgb(137, 137, 137)','heather-navy': 'rgb(109, 129, 150)','irish-green': 'rgb(76, 187, 23)','daisy': 'rgb(255, 222, 33)','sport-grey': 'rgb(211, 211, 211)','natural': 'rgb(250, 235, 215)','navy-blazer': 'rgb(0, 0, 128)','charcoal-heather': 'rgb(137, 137, 137)','team-royal': 'rgb(48, 92, 222)','team-red': 'rgb(218, 44, 67)','carbon-grey': 'rgb(211, 211, 211)','azalea': 'rgb(237, 128, 233)','vintage-black': 'rgb(24, 19, 14)','dust': 'rgb(240, 239, 235)','athletic-heather': 'rgb(192, 192, 192)','military-green': 'rgb(57, 83, 60)','oak-bork': 'rgb(106, 141, 65)','earth-powder': 'rgb(144, 115, 80)','warm-slate-grey': 'rgb(169, 169, 169)','wild-honey': 'rgb(189, 73, 50)','silk-moss-green': 'rgb(217, 234, 211)','black-matt': 'rgb(40, 40, 43)','dark-sand': 'rgb(168, 143, 89)','asphalt-schwarz': 'rgb(75, 75, 80)','graphite-heather': 'rgb(75, 78, 83)','tropical-blue': 'rgb(72, 177, 216)','sand': 'rgb(231, 221, 185)','ash': 'rgb(241, 241, 241)','heliconia': 'rgb(245, 89, 149)','sky': 'rgb(119, 196, 254)','yellow-haze': 'rgb(244, 218, 146)','passion-red': 'rgb(146, 22, 45)','gun-metal-black': 'rgb(22, 24, 29)','schwarz': 'rgb(0, 0, 0)','slate-grey-black': 'rgb(128, 128, 128)','vanilla-passion-red': 'rgb(253, 247, 228)','starfield-purple-warm-slate': 'rgb(16, 40, 111)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
